<template>
  <b-modal size="lg" hide-footer id="ModalBuscaNcm">
    <Header titulo="RESULTADOS DA PESQUISA" cor="azul" slot="modal-header" :close="cancelar" />
    <div>
      <div v-if="exibeTabelaBuscaNcm && !carregandoTabelaNcm" class="input-modal-busca-ncm">
        <div class="tabela-busca-ncm-titulo">
          Resultados relacionados ao termo pesquisado "{{ termoPesquisado }}"
        </div>
        <div class="modal-busca-ncm-input">
          <CenarioInput
            placeholder="Pesquisar por NCM ou descrição"
            tipo="texto"
            :model="strPesquisa"
            @update:model="update => (strPesquisa = update)"
          />
          <div>
            <BotaoPadrao
              tipo="icone"
              class="botao-padding"
              :icone="inverteRelevancia ? 'sort-amount-down' : 'sort-amount-up'"
              cor="azul"
              :click="ordenaRelevancia"
              :tooltip="
                inverteRelevancia
                  ? 'Ordenar por relevância crescente'
                  : 'Ordenar por relevância decrescente'
              "
            />
          </div>
        </div>
        <div class="tabela-busca-ncm-label">
          Selecione abaixo a opção de NCM correspondente ao seu produto.
        </div>
        <TabelaBuscaNcm
          class="tabela-busca-ncm"
          :conteudo="conteudo"
          :conteudoFiltrado="conteudoFiltrado"
          :selecionaNcm="handleSelecionaNcm"
          :apagaOrdenacao="apagaOrdenacao"
        />
      </div>
      <LoadingPadraoContainer
        class="tabela-busca-ncm"
        v-else-if="carregandoTabelaNcm"
        :fraseLoading="['Carregando lista de NCMs', 'Aguarde um momento']"
        delay="5000"
        classe="azul"
      />
    </div>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import TabelaBuscaNcm from "./TabelaBuscaNcm.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";
import CenarioInput from "@/components/CenarioInput/CenarioInput.vue";
import stringFormatMixin from "@/mixins/stringFormatMixin";

export default {
  name: "ModalBuscaNcm",
  components: {
    BotaoPadrao,
    Header,
    TabelaBuscaNcm,
    LoadingPadraoContainer,
    CenarioInput
  },
  props: {
    conteudoTabelaNcm: Array,
    selecionaNcm: Function,
    termoPesquisado: String,
    exibeTabelaBuscaNcm: Boolean,
    carregandoTabelaNcm: Boolean
  },
  mixins: [stringFormatMixin],
  data() {
    return {
      apagaOrdenacao: false,
      strPesquisa: "",
      conteudo: [],
      inverteRelevancia: false
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  watch: {
    conteudoTabelaNcm: {
      deep: true,
      handler() {
        this.conteudo = this.conteudoTabelaNcm.map(p => ({ ...p }));
      }
    }
  },
  computed: {
    conteudoFiltrado() {
      if (this.strPesquisa.length > 0) {
        return this.conteudo.filter(
          f =>
            f.ncm.replaceAll(".", "").includes(this.strPesquisa.replaceAll(".", "")) ||
            this.removerAcentos(f.descricao).includes(this.removerAcentos(this.strPesquisa))
        );
      }
      return this.conteudo;
    }
  },
  methods: {
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalBuscaNcm");
    },
    handleSelecionaNcm(ncm) {
      this.selecionaNcm(ncm, false);
      this.cancelar();
    },
    ordenaRelevancia() {
      let ordena = this.conteudoTabelaNcm.map(p => ({ ...p }));
      this.conteudo = this.inverteRelevancia ? ordena : ordena.reverse();
      this.inverteRelevancia = !this.inverteRelevancia;
      this.apagaOrdenacao = !this.apagaOrdenacao;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-modal-busca-ncm {
  padding: 0 30px;
}
.tabela-busca-ncm-titulo {
  margin-bottom: 10px;
}
.modal-busca-ncm-input {
  display: flex;
}
.tabela-busca-ncm-label {
  margin-top: 10px;
}
</style>
